import React, { useState } from 'react';
import { Radio, Button, message, Modal, Input} from 'antd';
import DomainInfo from './DomainInfo';
import { SettingAPI } from '../../../../requests';
import { baseInfo } from '../interface';
import DomainStatus from './DomainStatus'
import './style.less';

const clsPrefix = 'cn-bound-domain';


interface BoundDomainProps {
  baseInfo: baseInfo,
  siteId?: string,
  execute?: () => void,
}

const BoundDomain: React.FC<BoundDomainProps> = ({
  siteId,
  baseInfo,
  execute,
}) => {
  const { privateDomain, leftTime, status, curOrigin, sslHelperInfo, sslOwnerInfo } = baseInfo
  const [domainSource, setDomainSource] = useState(curOrigin? curOrigin: 'OWNER');
  const [data, setData] = useState({
    certificatePem:sslOwnerInfo && sslOwnerInfo.certificatePem,
    certificateKey:sslOwnerInfo && sslOwnerInfo.certificateKey,
    isChange: false
  })
  const [loading, setLoading] = useState(false)
  function handleRadio (value:any) {
    Modal.confirm({
      title: value === 'OWNER'? '确定切换到自有证书吗?' : '确定切换到快站自动生成证书吗？',
      content: value === 'OWNER'? '' : '快站将自动为您域名申请证书，并部署到cdn节点。',
      okText: '确定',
      cancelText: '取消',
      async onOk(){
        const result = await SettingAPI.changeOrigin(
          {
            domainStr: privateDomain,
            certificateOrigin: value,
          }
        )
        setDomainSource(value)
      },
      onCancel(){}
    })
  }
  
  function  handleData (e:any, name:'certificatePem' | 'certificateKey'){
    const isChange:boolean = e.target.value !== (sslOwnerInfo && sslOwnerInfo[name])
    setData({
      ...data,
      [name]:e.target.value,
      isChange: isChange,
    })
  }

  function handleSubmit (){
    if (data.certificatePem && data.certificateKey) {
      setLoading(true)
      SettingAPI.selfDeployCertificate({
        privateKey: data.certificateKey,
        certificateContent: data.certificatePem,
        domainStr: privateDomain
      }).then((res:any) => {
        setLoading(false)
        if (res.code && res.code !== 200) {
          message.error(res.msg && res.msg)
        } else {
          message.success('保存成功，稍后刷新查看部署状态')
        }
      }).catch((error:any) => {
        setLoading(false)
        message.error('保存失败，请重试')
      })
    } else {
      message.error('证书或私钥内容不能为空')
    }
  }

  return (
    <div className={clsPrefix}>
      <DomainInfo 
        privateDomain={ baseInfo && baseInfo.privateDomain}
        leftTime={leftTime}
        status={status}
        siteId={siteId}
      />
      <div className={`${clsPrefix}__setting-wrap`} style={{display: status !== 2? 'none': 'block'}}>
        <div className={`${clsPrefix}__title`}>
          配置证书
        </div>
        <div className={`${clsPrefix}__radio`}>
          <span className={`${clsPrefix}__radio-title`}>证书来源</span>
          <Radio.Group onChange={e => handleRadio(e.target.value)} value={domainSource}>
            <Radio value='OWNER'>自有证书</Radio>
            <Radio value='HELPER'>快站自动生成证书</Radio>
          </Radio.Group>
        </div>
        {domainSource === 'OWNER' && (
          <div className={`${clsPrefix}__form`}>
              <div className={`${clsPrefix}__form-item`}>
                <span>证书内容</span>
                <Input.TextArea 
                  rows={4}
                  style={{width:'340px',verticalAlign:'top'}}
                  value={data.certificatePem} 
                  onChange={e =>handleData(e, 'certificatePem')}
                />
              </div>
              <div className={`${clsPrefix}__form-item`}>
                <span>私钥内容</span>
                <Input.TextArea
                  rows={4}
                  style={{width:'340px',verticalAlign:'top'}}
                  value={data.certificateKey}
                  onChange={e =>handleData(e, 'certificateKey')}
                />
              </div>
              <DomainStatus privateDomain={privateDomain} domainSource={domainSource} />
              {(data.isChange || !(sslOwnerInfo && sslOwnerInfo.certificateKey)) && 
                <Button onClick={() => handleSubmit()} type='primary' loading={loading}>保存并部署</Button>
              }
          </div>
          )
        }
        {domainSource === 'HELPER' && (
          <>
            <DomainStatus privateDomain={privateDomain} domainSource={domainSource} />
          </>
        )}
      </div>
    </div>
  )
}

export default BoundDomain;